export default __webpack_public_path__ + "static/media/menu-homeWhite.200d5318.svg";